import React from 'react';
import Chart, {
  ArgumentAxis,
  CommonSeriesSettings,
  Legend,
  Series,
  Tooltip,
  ValueAxis,
  ConstantLine,
  Label,
} from 'devextreme-react/chart';

interface Props {
  title: string;
  array: any
}

function MsiChart(props: Props) {
  const { title, array } = props;

  const data = array.sort((a: any, b: any) => b.count - a.count);
  const totalCount = data.reduce((prevValue: any, item: any) => prevValue + item.count, 0);
  let cumulativeCount = 0;

  const dataArray = data.map((item: any) => {
    cumulativeCount += item.count;
    return {
      complaint: item.complaint,
      count: item.count,
      cumulativePercentage: Math.round((cumulativeCount * 100) / totalCount),
    };
  });

  function customizePercentageText({ valueText }: { valueText: any }) {
    return `${valueText}%`;
  }

  return (
    <Chart
      title={title}
      dataSource={dataArray}
      palette="Harmony Light"
      id="chart"
    >
      <CommonSeriesSettings argumentField="complaint" />
      <Series
        name="Complaint frequency"
        valueField="count"
        axis="frequency"
        type="bar"
        color="#fac29a"
      />
      <Series
        name="Cumulative percentage"
        valueField="cumulativePercentage"
        axis="percentage"
        type="spline"
        color="#6b71c3"
      />

      <ArgumentAxis>
        <Label overlappingBehavior="stagger" />
      </ArgumentAxis>

      <ValueAxis name="frequency" position="left" tickInterval={300} />
      <ValueAxis
        name="percentage"
        position="right"
        tickInterval={20}
        showZero={true}
        valueMarginsEnabled={false}
      >
        <Label customizeText={customizePercentageText} />
        <ConstantLine value={80} width={2} color="#fc3535" dashStyle="dash">
          <Label visible={false} />
        </ConstantLine>
      </ValueAxis>

      {/* <Tooltip enabled={true} shared={true} customizeTooltip={customizeTooltip} /> */}
      <Tooltip enabled={true} shared={true} />

      <Legend verticalAlignment="top" horizontalAlignment="center" />
    </Chart>
  );
}

export default MsiChart;